import * as React from 'react';
import Layout from '../components/Utilities/Layout';
import { Alert, Box, Button, Chip, ChipPropsColorOverrides, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, LinearProgress, MenuItem, Select, SelectChangeEvent, Stack, TextField, Typography } from '@mui/material';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import Common from '../utilities/common';
import $ from "jquery";
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import { DataGrid } from '@mui/x-data-grid';
import { BorderBottom } from '@mui/icons-material';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import NormalizationResume from './NormalizationResume';
import ResumeChart from './ResumeChart';
import ResultTable from './ResultTable';
import EditRoadOutlinedIcon from '@mui/icons-material/EditRoadOutlined';
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import VillaOutlinedIcon from '@mui/icons-material/VillaOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import QueryBuilderOutlinedIcon from '@mui/icons-material/QueryBuilderOutlined';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import NormalizationDashboard from './NormalizationDashboard';
import ReactInterval from 'react-interval';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import FeatureManager from '../components/Utilities/FeatureManager';

export interface IDetalleNormalizacionState {
    normalizationData: any;
    normalizationLog: any[];
    timer: any;
    openDeleteDialog: boolean;
    openConsolidateDialog: boolean;
    chartItemClick: string;
    chartItemError: boolean;
}

export default class DetalleNormalizacion extends React.Component<{}, IDetalleNormalizacionState> {
    _file: any;
    _fileContent: any[] = [];

    public constructor(props: {}) {
        super(props);

        this.state = {
            normalizationData: null,
            normalizationLog: [],
            timer: null,
            openDeleteDialog: false,
            openConsolidateDialog: false,
            chartItemClick: '',
            chartItemError: false
        };
    }

    componentDidMount(): void {
        this.Get();
        this.GetLog();
    }

    public render(): React.ReactElement<{}> {
        return (
            <FeatureManager entidad={Entity.Normalizaciones} operacion='Ver' showBuyOption>
                <SecurityTrimmer entity={Entity.Normalizaciones} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                    <Layout breadcrumb={
                        [
                            {
                                title: 'Inicio',
                                url: '/'
                            },
                            {
                                title: 'Normalizaciones',
                                url: '/normalizaciones'
                            },
                            {
                                title: 'Detalle',
                                url: ''
                            }
                        ]
                    }>
                        <ReactInterval timeout={1000} enabled={(this.state.normalizationData != null && this.state.normalizationData.status != 'Finalizado' && this.state.normalizationData.status != 'Consolidada')} callback={() => {
                            this.Get();
                            this.GetLog();
                        }}/>
                        <Box className='stepper'>
                            <Grid container>
                                <Grid item xs={1}>
                                    <Typography>
                                        <SettingsSuggestOutlinedIcon className='mainIcon'/>
                                    </Typography>
                                </Grid>
                                <Grid item xs={11}>
                                    <Typography className='mainTitle'>
                                    Detalle del proceso de normalización
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box className='main'>
                            <Grid container style={{borderBottom: 'solid 1px #333', marginBottom: '20px'}}>
                                <Grid item xs={10}>
                                {
                                    this.state.normalizationData != null && (
                                        <Typography variant='h6'>
                                            {
                                                this.state.normalizationData.path.split('\\')[this.state.normalizationData.path.split('\\').length - 1]
                                            }
                                        </Typography>
                                    )
                                }
                                </Grid>
                                <Grid item xs={2} style={{textAlign: 'right'}}>
                                {
                                    this.state.normalizationData != null && (
                                        <Chip icon={this.GetIcon()} label={this.state.normalizationData.status} color={this.GetColor()} style={{position: 'relative', top : '-5px'}}/>
                                    )
                                }   
                                </Grid>
                            </Grid>
                            <Stack direction={'row'} alignItems={'center'} justifyContent={'flex-start'} style={{marginTop: '20px'}} gap={'20px'} whiteSpace={'break-spaces'}>
                                {
                                    this.state.normalizationData != null && (
                                        <Box className='square bigger grey'>
                                            <Typography gutterBottom variant="body2" color='text.secondary' component="div">
                                            Fecha de solicitud
                                            </Typography>
                                            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-around'} style={{marginTop: '20px'}}>
                                                <CalendarMonthOutlinedIcon titleAccess='Fecha de solicitud' style={{fontSize: '36px', opacity: '.7'}}/>
                                                <Typography variant='body2' color="text.secondary" gutterBottom textAlign='center' paddingTop={'10px'} fontSize={'1.2em'} fontWeight={300}>
                                                    {
                                                        new Date(this.state.normalizationData.date).toLocaleDateString()
                                                    }
                                                </Typography>
                                            </Stack>
                                        </Box>
                                    )
                                }                            
                                {
                                    this.state.normalizationData != null && this.state.normalizationData.status != 'Pendiente' && (
                                        <Box className='square bigger grey'>
                                            <Typography gutterBottom variant="body2" color='text.secondary' component="div">
                                            Hora de inicio
                                            </Typography>
                                            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-around'} style={{marginTop: '20px'}}>
                                                <PlayCircleOutlineOutlinedIcon titleAccess='Hora de inicio' style={{fontSize: '36px', opacity: '.7'}}/>
                                                <Typography variant='body2' color="text.secondary" gutterBottom textAlign='center' fontSize={'1.2em'} fontWeight={300}>
                                                {
                                                    `${new Date(this.state.normalizationData.startTime).toLocaleDateString()} ${new Date(this.state.normalizationData.startTime).toLocaleTimeString()}`
                                                }
                                                </Typography>
                                            </Stack>
                                        </Box>
                                    )
                                }   
                                {
                                    this.state.normalizationData != null && (this.state.normalizationData.status == 'Error' || this.state.normalizationData.status == 'Finalizado' || this.state.normalizationData.status == 'Consolidada') && (
                                        <Box className='square bigger grey'>
                                            <Typography gutterBottom variant="body2" color='text.secondary' component="div">
                                            Hora de finalización
                                            </Typography>
                                            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-around'} style={{marginTop: '20px'}}>
                                                <StopCircleOutlinedIcon style={{fontSize: '36px', opacity: '.7'}}/>
                                                <Typography variant='body2' color="text.secondary" gutterBottom textAlign='center' fontSize={'1.2em'} fontWeight={300}>
                                                {
                                                    `${new Date(this.state.normalizationData.endTime).toLocaleDateString()} ${new Date(this.state.normalizationData.endTime).toLocaleTimeString()}`
                                                }
                                                </Typography>
                                            </Stack>
                                        </Box>
                                    )
                                }
                                {
                                    this.state.normalizationData != null && (
                                        <Box className='square bigger grey'>
                                            <Typography gutterBottom variant="body2" color='text.secondary' component="div">
                                            Tipo de normalización
                                            </Typography>
                                            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-around'} style={{marginTop: '20px'}}>
                                                <SettingsSuggestOutlinedIcon style={{fontSize: '36px', opacity: '.7'}}/>
                                                <Typography variant='body2' color="text.secondary" gutterBottom textAlign='center' fontSize={'1.2em'} fontWeight={300}>
                                                {
                                                    this.state.normalizationData.actions.split(',').join(', ')
                                                }
                                                </Typography>
                                            </Stack>
                                        </Box>
                                    )
                                }
                            </Stack>
                            {
                                this.state.normalizationData != null && this.state.normalizationData.status == 'Pendiente' && (
                                    <Alert severity="info" style={{marginTop: '20px'}}>Esperando que se inicie el proceso de normalización</Alert>
                                )
                            }
                            {
                                this.state.normalizationData != null && this.state.normalizationData.status == 'Activo' && (
                                    <React.Fragment>
                                        {
                                            this.state.normalizationLog[0] != null && (
                                                <Typography variant='body2' color="text.secondary" style={{marginTop: '20px'}}>
                                                    {
                                                        this.state.normalizationLog[0].message
                                                    }
                                                </Typography>
                                            )
                                        }
                                        {
                                            this.state.normalizationLog[0] != null && (
                                                <Grid container>
                                                    <Grid item xs={12} style={{marginBottom: '20px'}}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <Box sx={{ width: '100%', mr: 1 }}>
                                                                <LinearProgress variant="determinate" value={this.state.normalizationData.progress} />
                                                            </Box>
                                                            <Box sx={{ minWidth: 35 }}>
                                                                <Typography variant="body2" color="text.secondary">
                                                                    {
                                                                        `${this.state.normalizationData.progress}%`
                                                                    }
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            )
                                        }
                                    </React.Fragment>
                                )
                            }
                        </Box>
                        <Box>
                        {
                            this.state.normalizationData != null && this.state.normalizationData.status != 'Pendiente' && (
                                <NormalizationDashboard normalization={this.state.normalizationData} onItemClick={(data: string, error: boolean) => {
                                    this.setState(
                                        {
                                            chartItemClick: data,
                                            chartItemError: data == null ? false : error
                                        }
                                    );
                                }}/>
                            )
                        }
                        </Box>
                        <Box className='main'>
                        {
                            this.state.normalizationData != null && this.state.normalizationData.status != 'Pendiente' && (
                                <ResultTable normalization={this.state.normalizationData} filterKey={this.state.chartItemClick} filterError={this.state.chartItemError}/>
                            )
                        }
                        </Box>
                        <Box className='stepper'textAlign={'right'}>
                            {
                                this.state.normalizationData != null && (this.state.normalizationData.status == 'Error' || this.state.normalizationData.status == 'Finalizado') && (
                                    <React.Fragment>
                                        {
                                            this.state.normalizationData.status == 'Error' && (
                                                <FeatureManager entidad={Entity.Normalizaciones} operacion='Editar'>
                                                    <SecurityTrimmer entity={Entity.Normalizaciones} permission={PermissionLevel.Crear}>
                                                        <Button 
                                                            variant="contained" 
                                                            startIcon={<CachedOutlinedIcon />}
                                                            onClick={this.Reset.bind(this)}>
                                                            Reiniciar normalización
                                                        </Button>
                                                    </SecurityTrimmer>
                                                </FeatureManager>
                                            )
                                        }
                                        {
                                            (this.state.normalizationData.status == 'Finalizado' || this.state.normalizationData.status == 'Error') && (
                                                <FeatureManager entidad={Entity.Normalizaciones} operacion='Crear'>
                                                    <SecurityTrimmer entity={Entity.Consolidaciones} permission={PermissionLevel.Crear}>
                                                        <Button 
                                                            variant="contained" 
                                                            startIcon={<StorageOutlinedIcon/>}
                                                            onClick={() => {
                                                                this.setState(
                                                                    {
                                                                        openConsolidateDialog: true
                                                                    }
                                                                );
                                                            }}>
                                                            CONSOLIDAR
                                                        </Button>
                                                    </SecurityTrimmer>
                                                </FeatureManager>
                                            )
                                        }
                                        {
                                            (this.state.normalizationData.status == 'Finalizado' || this.state.normalizationData.status == 'Error') && (
                                                <FeatureManager entidad={Entity.Normalizaciones} operacion='Eliminar'>
                                                    <SecurityTrimmer entity={Entity.Normalizaciones} permission={PermissionLevel.Eliminar}>
                                                        <Button 
                                                            variant="contained"
                                                            color="error"
                                                            startIcon={<DeleteOutlineOutlinedIcon />}
                                                            onClick={() => {
                                                                this.setState({
                                                                    openDeleteDialog: true
                                                                })
                                                            }}>
                                                            ELIMINAR NORMALIZACIÓN
                                                        </Button>
                                                    </SecurityTrimmer>
                                                </FeatureManager>
                                            )
                                        }
                                    </React.Fragment>
                                )
                            }
                            <Dialog open={this.state.openDeleteDialog} fullWidth>
                                <DialogTitle>
                                    {
                                        `Eliminar datos de la normalización`
                                    }
                                </DialogTitle>
                                <DialogContent>
                                    <Typography variant='body2' style={{marginBottom: '10px'}}>
                                        {
                                            `Esta operación eliminará todos los datos de la normalización. ¿Desea continuar?`
                                        }
                                    </Typography>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.DeleteNormalization.bind(this)}>Sí</Button>
                                    <Button onClick={() => {
                                        this.setState({
                                            openDeleteDialog: false
                                        })
                                    }}>No</Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog open={this.state.openConsolidateDialog} fullWidth>
                                <DialogTitle>
                                    {
                                        `Consolidación de datos`
                                    }
                                </DialogTitle>
                                <DialogContent>
                                    <Typography variant='body2' style={{marginBottom: '10px'}}>
                                        {
                                            `Esta operación consolidará los registros correctos en la base de datos y los eliminará de los datos normalizados. Ten en cuenta que es posible que algunos registros ya existan en la base de datos, por lo que el número final de registros consolidados puede no coincidir con el número de registros normalizados sin errores.`
                                        }
                                    </Typography>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.Consolidate.bind(this)}>Ok</Button>
                                    <Button onClick={() => {
                                        this.setState(
                                            {
                                                openConsolidateDialog: false
                                            }
                                        );
                                    }}>Cancelar</Button>
                                </DialogActions>
                            </Dialog>
                        </Box>
                    </Layout>
                </SecurityTrimmer>
            </FeatureManager>
        )
    }

    private DeleteNormalization() {
        let url = `${Common.END_POINT}/normalizaciones/${this.state.normalizationData.id}/delete`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            window.location.href = '/';
        });
    }

    private Get(): void {
        const id = Common.getUrlParam('n');

        let url = `${Common.END_POINT}/normalizaciones/${id}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    normalizationData: response[0],
                    timer: null
                }
            );

            this.GetErrorsTotal(response[0]);
        });
    }

    private GetLog(): void {
        const id = Common.getUrlParam('n');

        let url = `${Common.END_POINT}/normalizaciones/${id}/log`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    normalizationLog: response
                }
            );
        });
    }

    private GetErrorsTotal(normalizationData: any): void {
        const id = Common.getUrlParam('n');
        let url = `${Common.END_POINT}/normalizaciones/${id}/progress/errors/totals`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            let total: number = 0;
            for (let i = 0; i < response.length; i++) {
                total += response[i].errores;
            }

            /*if(total == 0 && normalizationData.status != 'Pendiente' && normalizationData.status != 'Consolidada' && normalizationData.status != 'Activo') {
                this.EndNormalization();
            }*/
        });
    }

    private EndNormalization(): void {
        const id = Common.getUrlParam('n');
        let url = `${Common.END_POINT}/normalizaciones/${id}/status`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify('Finalizado'),
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            
        })
    }

    private Reset(): void {
        let url = `${Common.END_POINT}/normalizaciones/${this.state.normalizationData.id}/reset`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.Get();
            this.GetLog();
        });
    }

    private Consolidate(): void {
        let url = `${Common.END_POINT}/normalizaciones/${this.state.normalizationData.id}/consolidate`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            window.location.href = "/consolidaciones";
        });
    }


    private GetColor(): any {
        if (this.state.normalizationData.status == 'Error') {
            return 'error';
        }

        if (this.state.normalizationData.status == 'Finalizado') {
            return 'success';
        }

        if (this.state.normalizationData.status == 'Consolidada') {
            return 'info';
        }
    }

    private GetIcon(): JSX.Element {
        if (this.state.normalizationData.status == 'Error') {
            return <ErrorOutlineOutlinedIcon />;
        }

        if (this.state.normalizationData.status == 'Finalizado') {
            return <CheckCircleOutlineOutlinedIcon />;
        }

        if (this.state.normalizationData.status == 'Pendiente') {
            return <QueryBuilderOutlinedIcon />;
        }

        return <CachedOutlinedIcon />;
    }
}